import { CommonModule } from '@angular/common';
import { Component, computed, inject } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { TranslateModule } from '@ngx-translate/core';
import { COMPANY_PROFILE_CARD_DATA_TOKEN } from '@galaxy/crm/static';
import { MatCardModule } from '@angular/material/card';
import { GalaxyBadgeModule } from '@vendasta/galaxy/badge';
import { CrmMarketplaceProductsAssociationCardService } from './products.service';
import { takeUntilDestroyed, toSignal } from '@angular/core/rxjs-interop';
import { GalaxyAvatarModule } from '@vendasta/galaxy/avatar';
import { GalaxyLoadingSpinnerModule } from '@vendasta/galaxy/loading-spinner';
import { NamespaceResolutionService } from '../../namespace-resolution.service';

const defaultMarket = 'default';

@Component({
  selector: 'app-bcc-crm-marketplace-products-association-card',
  imports: [
    CommonModule,
    TranslateModule,
    MatExpansionModule,
    MatCardModule,
    GalaxyBadgeModule,
    GalaxyAvatarModule,
    GalaxyLoadingSpinnerModule,
  ],
  templateUrl: './products.component.html',
  styleUrl: './products.component.scss',
  providers: [CrmMarketplaceProductsAssociationCardService],
})
export class ProductsComponent {
  private readonly service = inject(CrmMarketplaceProductsAssociationCardService);
  private readonly data = inject(COMPANY_PROFILE_CARD_DATA_TOKEN);
  private readonly namespaceResolutionService = inject(NamespaceResolutionService);

  protected readonly products = toSignal(this.service.products$);
  protected readonly isLoaded = computed(() => this.products() !== undefined);
  protected readonly hasProducts = computed(() => !!this.products()?.length);
  protected readonly hasFailed = toSignal(this.service.getProductsFailed$);

  constructor() {
    this.namespaceResolutionService.namespace$
      .pipe(takeUntilDestroyed())
      .subscribe((partnerId) => this.service.setPartnerId(partnerId));
    this.service.setAccountGroupId(this.data.account_group_id ?? '');
    this.service.setMarketId(this.data.group_id || defaultMarket);
  }

  protected handleProductClick(url: string): void {
    const parsedUrl = this.injectAccountId(url, this.data.account_group_id ?? '');
    window.open(parsedUrl, '_blank');
  }

  private injectAccountId(url: string, accountGroupId: string): string {
    return url.replaceAll('<accountId>', accountGroupId).replaceAll('%3CaccountId%3E', accountGroupId);
  }
}
